export default "__VITE_PUBLIC_ASSET__cafc8a9a__"